import { FC } from 'react';

import Section from 'molecules/Section';
import { splitSectionProps } from 'molecules/Section/config';
import TrustbarMolecule from 'molecules/Trustbar';

import { TrustbarConfigProps } from 'components/Trustbar/config';

const Trustbar: FC<TrustbarConfigProps> = props => {
  const { sectionProps, rest } = splitSectionProps(props);
  const { heading, trustBars } = rest;
  const isDark = !!sectionProps?.darkMode;

  return (
    <Section {...sectionProps}>
      <TrustbarMolecule heading={heading} trustBars={trustBars} isDark={isDark} />
    </Section>
  );
};

export default Trustbar;
